<template>
  <!-- prettier-ignore-->
  <v-card>
    <h1 v-if="errorMsg" id="error">{{errorMsg}}</h1>
    <v-card-title>Sleep Periods for &nbsp; <b>{{patientId}}</b>
      <v-spacer></v-spacer>
      <v-text-field
          v-model="search"
          append-icon="search"
          hide-details
          label="search"
          single-line
      ></v-text-field>
    </v-card-title>
    <v-dialog v-model="spin">
      <v-progress-linear
          color="blue"
          indeterminate
      ></v-progress-linear>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Sleep Period</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md4 md6 xs12>
                <v-text-field v-model="editedItem.sleepTime"
                              :rules="[validTime]"
                              label="Sleep Time"></v-text-field>
              </v-flex>
              <v-flex md4 md6 xs12>
                <v-text-field v-model="editedItem.awakeTime"
                              :rules="[validTime]"
                              label="Awake Time"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>

          <v-btn v-if="canSave()" color="blue darken-1"
                 text
                 @click="save">Save
          </v-btn>
          <v-btn v-else color="blue darken-1"
                 disabled
                 text
                 @click="save">Cannot Save
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
        :headers="headers"
        :items="sleepPeriods"
        :search="search" class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-x-right">{{ props.item.sleepDate }}</td>
        <td class="text-x-right">{{ props.item.sleepTime }}</td>
        <td class="text-x-right">{{ props.item.awakeTime }}</td>
        <td class="justify-center layout px-0">
          <v-icon
              class="mr-2"
              small
              @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>

  </v-card>
</template>
<script>
import { AXIOS } from '@/http/axios'
import { defaultSleepPeriodVM, toSleepPeriodVM } from '@/view-model/SleepPeriodVM'
import { currentTimestamp, ONE_HOUR, toTimestamp } from '@/utils/time'

function isValidTimeString(v) {
  try {
    const newTs = toTimestamp(v)
    if (newTs) {
      return true
    }
    return false
  } catch (e) {
    return false
  }
}

const Page = {
  name: 'SleepPeriods',

  data() {
    return {
      sleepTimeSnack: false,
      sleepTimeSnackColor: '',
      sleepTimeSnackText: '',
      msg: 'get patients:',
      dialog: false,
      spin: false,
      editedIndex: -1,
      editedItem: defaultSleepPeriodVM(),
      defaultItem: defaultSleepPeriodVM(),
      patientId: '',
      search: '',
      headers: [
        {
          text: 'Date',
          sortable: true,
          value: 'sleepDate',
        },
        {
          text: 'SleepTime',
          sortable: false,
          value: 'sleepTime',
        },
        {
          text: 'AwakeTime',
          sortable: false,
          value: 'awakeTime',
        },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      sleepPeriods: [],
      response: [],
      errorMsg: '',
    }
  },

  // hooks
  beforeCreate() {
    console.log('Before created')
  },

  beforeMount() {
    const patientId = this.$route.params['patient_id']
    if (!patientId) {
      throw new Error('We need a patient id')
    }
    this.patientId = patientId
    this.getSleepPeriods(patientId)
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close()
      }
    },
  },

  methods: {
    // Fetches posts when the component is created.
    getSleepPeriods(patientId) {
      AXIOS.get(`/sleep-periods/${patientId}`)
        .then(response => {
          // JSON responses are automatically parsed.
          this.sleepPeriods = response.data.map(toSleepPeriodVM)
          console.log(response.data)
        })
        .catch(e => {
          this.errorMsg = e.message
        })
    },

    validTime: v => {
      if (isValidTimeString(v)) {
        return true
      } else {
        return 'Not a valid time'
      }
    },
    cancel() {
      this.sleepTimeSnack = true
      this.sleepTimeSnackColor = 'error'
      this.sleepTimeSnackText = 'Canceled'
    },
    close() {
      console.log('Closed called')
      this.dialog = false
      setTimeout(function() {
        this.editedItem = defaultSleepPeriodVM()
        this.editedIndex = -1
      }, 300)
    },
    canSave() {
      const earliestTs = toTimestamp('2010-01-01')
      const maxSleepDuration = 18 * ONE_HOUR
      const latestTs = currentTimestamp()
      const itemToSave = this.editedItem
      const sleepTs = toTimestamp(itemToSave.sleepTime)
      const awakeTs = toTimestamp(itemToSave.awakeTime)
      const sleepDuration = awakeTs - sleepTs
      return (
        sleepTs &&
        awakeTs &&
        awakeTs >= sleepTs &&
        sleepTs > earliestTs &&
        awakeTs <= latestTs &&
        sleepDuration < maxSleepDuration
      )
    },
    save() {
      this.spin = true
      const _this = this

      function addAfterDeletion() {
        _this._addItem(_this.editedItem)
      }

      this._deleteItem(this.sleepPeriods[this.editedIndex], addAfterDeletion)
      this.close()
    },
    editItem(item) {
      this.editedIndex = this.sleepPeriods.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    _addItem(item) {
      const patientId = this.patientId
      AXIOS.post(`/sleep-periods/add/${patientId}`, {
        sleepTime: toTimestamp(item.sleepTime),
        awakeTime: toTimestamp(item.awakeTime),
      })
        .then(response => {
          console.log(response.data)
          this.$router.go(0)
        })
        .catch(e => {
          this.errorMsg = e.message
        })
    },
    _deleteItem(item, next) {
      const patientId = this.patientId
      AXIOS.post(`/sleep-periods/delete/${patientId}`, {
        sleepTime: item.sleepTimeTs,
        awakeTime: item.awakeTimeTs,
      })
        .then(response => {
          console.log(response.data)
          // refresh page
          if (next) {
            next()
          }
        })
        .catch(e => {
          this.errorMsg = e.message
        })
    },

    deleteItem(item) {
      if (confirm('Are you sure you want to delete this item?')) {
        const index = this.sleepPeriods.indexOf(item)
        this.sleepPeriods.splice(index, 1)
        this._deleteItem(item)
      }
    },
  },
}
export default Page
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#error {
  color: #a61717;
}
</style>
